import type { AuthState } from '@wix/cli-auth';
import { getSiteRevision } from '@wix/ambassador-typok-v1-siterevision/http';
import { httpRequest } from '../http-request.js';
import type { Logger } from '../logger.js';

export const getLatestRevision = async (opts: {
  authState: AuthState;
  logger: Logger;
}) => {
  try {
    const pagesResponse = await httpRequest(
      {
        type: 'editor',
        authState: opts.authState,
      },
      getSiteRevision({})
    );
    return pagesResponse.data.siteRevision?.revision ?? null;
  } catch (e) {
    opts.logger.logFailedToGetLatestRevision(e);
  }
  return null;
};
